import type { StateSchema } from '@/app/providers/storeProvider';
import { initialState } from '../../const/initialState';

export const getAuthLoading = (state: StateSchema) =>
    state.auth?.loading ?? initialState.loading;
